import * as React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from '@mui/material';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DebugService from '../../../services/DebugService';
import WeekDaySelector from '../WeekdaySelector';
import { useCurrentInstanceType } from '../Helper';
import TimezoneSelect from 'react-timezone-select';
import dayjs from 'dayjs';
import '../Styles.css'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

/**
 * Instance Scheduler Component
 * @param {*} param0 
 * @returns 
 */
export default function InstanceScheduler({ open, handleClose, onSave, instanceData }) {
    const defaultDayjsDate = dayjs().add(1, 'minute').second(0)

    const [weeklyScheduleFromDate, setWeeklyScheduleFromDate] = useState(defaultDayjsDate);
    const [weeklyScheduleEndDate, setWeeklyScheduleEndDate] = useState(defaultDayjsDate);
    const [weeklyStartTime, setWeeklyStartTime] = useState(defaultDayjsDate);
    const [weeklyStopTime, setweeklyStopTime] = useState(defaultDayjsDate);

    const [timezoneValue, setTimezoneValue] = useState('default');
    const [stopdate, setStopDate] = useState(defaultDayjsDate);
    const [startdate, setStartDate] = useState(defaultDayjsDate);
    const [recurringOption, setRecurringOption] = useState('CUSTOM');
    const [selectedDays, setSelectedDays] = useState([]);
    const [desireCount, setDesireCount] = useState(instanceData?.[0]?.['DesiredCapacity'] ?? 0);
    const [minimumCount, setMinimumCount] = useState(instanceData?.[0]?.['MinSize'] ?? 0);

    const [selectedTimezone, setSelectedTimezone] = useState(
        Intl.DateTimeFormat().resolvedOptions().timeZone,
    )

    const { type } = useCurrentInstanceType()

    const recurringOptionList = [
        {
            id: 1,
            label: 'Custom',
            value: 'CUSTOM',
            info: 'Instances will stop at selected stop date and will start at selected start date',
            isActive: true
        },
        {
            id: 2,
            label: 'Daily',
            value: 'DAILY',
            info: 'Instances will stop and start at the selected times daily between the chosen dates',
            isActive: true
        },
        {
            id: 3,
            label: 'Weekly',
            value: 'WEEKLY',
            info: 'Instances will stop and start at the selected days weekly between the chosen dates',
            isActive: true
        },
    ]

    DebugService.log(`Instance Scheduler: is called`, open, instanceData)

    const recurringSelectHandler = (event) => {
        DebugService.log(`Instance Scheduler: Selected recurring option`, event)
        setRecurringOption(event['target']['value'])
    }

    const daysSelectHandler = (selectedDayList) => {
        setSelectedDays(selectedDayList)
    }

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={true}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    },
                },
            }}
            PaperProps={{
                sx: {
                    borderRadius: '29px',
                    border: '1px solid #BDE0FF',
                    background: '#FFF',
                    boxShadow: '0px 4px 20px 0px #E3F0FC',
                    padding: 4,
                },
            }}
            className='schedule-modal'
        >

            <DialogTitle id="customized-dialog-title">
                <Typography className='heading' variant="h5">Schedule {type === 'asg' ? 'Auto-Scaling' : 'Shutdown'}</Typography>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#A9B3BB',
                }}
            >
                <img src='../../close-icon.svg' alt='Close Icon' width={'26px'} height={'26px'} />
            </IconButton>
            <DialogContent>
                <Grid container spacing={1} rowGap={'10px'} >
                    <Grid item xs={12}>
                        <TableContainer className='table-container'>
                            <Table size='small'>
                                <TableHead>
                                    {instanceData && (
                                        <TableRow>
                                            <TableCell className='no-bottom-border'><Typography variant='h6' className='table-th-cell'>Instance</Typography></TableCell>
                                            {type !== 'asg' && <TableCell className='no-bottom-border'><Typography variant='h6' className='table-th-cell'>Status</Typography></TableCell>}
                                        </TableRow>
                                    )}
                                </TableHead>
                                <TableBody>
                                    {instanceData && instanceData.map(item => (
                                        <TableRow key={item['id']}>
                                            {type === 'rds' && <TableCell className='no-bottom-border'><Typography variant='subtitle2' textAlign={'center'}>{item['DBInstanceIdentifierList']}</Typography></TableCell>}
                                            {type === 'asg' && <TableCell className='no-bottom-border'><Typography variant='subtitle2' textAlign={'center'}>{item['id']}</Typography></TableCell>}
                                            {!['rds'].includes(type) && <TableCell className='no-bottom-border'><Typography variant='subtitle2' textAlign={'center'}>{item['name']}</Typography></TableCell>}

                                            {type !== 'asg' && <TableCell className='no-bottom-border'><Typography variant='subtitle2' textAlign={'center'}>{type === 'rds' ? item['Status'] : item['instanceState'] ?? ''}</Typography></TableCell>}
                                        </TableRow>
                                    ))}
                                </TableBody>
                                {/* <TableBody>
                                {selectedRunningDBS?.map(item => (
                                    <TableRow key={item}>
                                        <TableCell>{item}</TableCell>
                                        <TableCell>{selectedRunningInstances || selectedRunningDBS ? 'available' : 'N/A'}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody> */}
                            </Table>
                        </TableContainer>
                    </Grid>

                    {/* Recurring selector */}
                    <Grid item xs={12}>
                        <FormControl size="small" fullWidth sx={{
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: 'rgba(217, 217, 217, 0.00)',
                                '& fieldset': {
                                    borderColor: '#A7BBCE',
                                    borderRadius: '7px'
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#425466', //Label color (default)
                            },
                            '& .MuiSelect-icon': {
                                color: '#506C84', //Dropdown arrow icon
                            },
                            '& .MuiSelect-select': {
                                color: '#425466', //Selected value color
                            },
                        }}>
                            <InputLabel id="demo-simple-select-label">Recurring Option</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                value={recurringOption}
                                label="Recurring Option"
                                onChange={recurringSelectHandler}
                            >
                                {recurringOptionList.filter(r => r['isActive']).map(r => (
                                    <MenuItem key={r['id']} value={r['value']}>{r['label']}</MenuItem>
                                ))}
                            </Select>
                            {recurringOption && <FormHelperText style={{ color: '#76818B' }}>Note:&nbsp;
                                {type === 'asg' ?
                                    'ASG will automatically decrease capacity on the configured downscale date time and increase capacity on the configured upscale date and time.'
                                    :
                                    recurringOptionList.filter(r => r['value'] === recurringOption)[0]?.['info'] ?? ''
                                }
                            </FormHelperText>}
                        </FormControl>
                    </Grid>

                    {['asg'].includes(type) && (
                        <Grid item container xs={12} spacing={1}>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    aria-readonly
                                    disabled
                                    label="Maximum Size"
                                    size='small'
                                    type='number'
                                    value={instanceData?.[0]?.['MaxSize']}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    label="Minimum Count"
                                    size='small'
                                    type='number'
                                    value={minimumCount}
                                    onChange={(e) => setMinimumCount(prev => {
                                        return (e['target']['value'] < 0) ? 0 : e['target']['value']
                                    })}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    label="Desire Count"
                                    size='small'
                                    type='number'
                                    value={desireCount}
                                    onChange={(e) => setDesireCount(prev => {
                                        return (e['target']['value'] < 0) ? 0 : e['target']['value']
                                    })}
                                />
                            </Grid>
                        </Grid>
                    )}

                    {['vmss'].includes(type) && (
                        <Grid item container xs={12} spacing={1}>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    aria-readonly
                                    disabled
                                    label="Maximum Capacity"
                                    size='small'
                                    type='number'
                                    value={instanceData?.[0]?.['maxCapacity']}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    label="Minimum Capacity"
                                    size='small'
                                    type='number'
                                    value={minimumCount}
                                    onChange={(e) => setMinimumCount(prev => {
                                        return (e['target']['value'] < 0) ? 0 : e['target']['value']
                                    })}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    label="Desire Capacity"
                                    size='small'
                                    type='number'
                                    value={desireCount}
                                    onChange={(e) => setDesireCount(prev => {
                                        return (e['target']['value'] < 0) ? 0 : e['target']['value']
                                    })}
                                />
                            </Grid>
                        </Grid>
                    )}

                    {/* Weekdays selector */}
                    {recurringOption === 'WEEKLY' && <Grid item xs={12}>
                        <WeekDaySelector onDaysSelection={daysSelectHandler} />
                    </Grid>}

                    {/* Timezone selector */}
                    {<Grid item xs={12} style={{
                        zIndex: 999
                    }}>
                        <TimezoneSelect value={selectedTimezone} onChange={(v) => {
                            setSelectedTimezone(v)

                            if (stopdate) {
                                setStopDate(stopdate.tz(v['value'] === 'Etc/GMT' ? 'UTC' : v['value']))
                            }

                            if (startdate) {
                                setStartDate(startdate.tz(v['value'] === 'Etc/GMT' ? 'UTC' : v['value']))
                            }

                            if (v['value'] === 'Etc/GMT') {
                                setTimezoneValue('UTC')
                            } else {
                                setTimezoneValue(v['value'])
                            }
                        }} />
                    </Grid>}

                    {/* Stop and Start datetime picker  */}
                    {recurringOption === 'WEEKLY' ? (
                        // Weekly Case
                        <>
                            <Grid item xs={12} sm={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']} sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#425466',
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: '#425466', //Label color (default)
                                        },
                                        '& .MuiSvgIcon-root': {
                                            color: '#506C84', //Dropdown arrow icon
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#425466', //Selected value color
                                            fontWeight: '600'
                                        },
                                    }}>
                                        <DatePicker
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                },
                                            }}
                                            value={weeklyScheduleFromDate}
                                            label={type === 'asg' ? 'Select Downscale Date' : 'Select From Date'}
                                            disablePast={true}
                                            timezone={timezoneValue}
                                            onChange={(value) => setWeeklyScheduleFromDate(value)}
                                            onError={() => setWeeklyScheduleFromDate(defaultDayjsDate)}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']} sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#425466',
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: '#425466', //Label color (default)
                                        },
                                        '& .MuiSvgIcon-root': {
                                            color: '#506C84', //Dropdown arrow icon
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#425466', //Selected value color
                                            fontWeight: '600'
                                        },
                                    }}>
                                        <DatePicker
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                },
                                            }}
                                            value={weeklyScheduleEndDate}
                                            timezone={timezoneValue}
                                            onChange={(newValue) => setWeeklyScheduleEndDate(newValue)}
                                            label={type === 'asg' ? 'Select Upscale Date' : 'Select End Date'}
                                            disablePast={true}
                                            onError={() => setWeeklyScheduleEndDate(defaultDayjsDate)}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['TimePicker']} sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#425466',
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: '#425466', //Label color (default)
                                        },
                                        '& .MuiSvgIcon-root': {
                                            color: '#506C84', //Dropdown arrow icon
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#425466', //Selected value color
                                            fontWeight: '600'
                                        },
                                    }}>
                                        <TimePicker
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                },
                                            }}
                                            value={weeklyStopTime}
                                            timezone={timezoneValue}
                                            onChange={(newValue) => setweeklyStopTime(newValue)}
                                            label={type === 'asg' ? 'Select Downscale Time' : 'Select Stop Time'}
                                            // disablePast={true}
                                            onError={() => setweeklyStopTime(defaultDayjsDate)}
                                            closeOnSelect={false}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['TimePicker']} sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#425466',
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: '#425466', //Label color (default)
                                        },
                                        '& .MuiSvgIcon-root': {
                                            color: '#506C84', //Dropdown arrow icon
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#425466', //Selected value color
                                            fontWeight: '600'
                                        },
                                    }}>
                                        <TimePicker
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                },
                                            }}
                                            value={weeklyStartTime}
                                            timezone={timezoneValue}
                                            onChange={(newValue) => setWeeklyStartTime(newValue)}
                                            label={type === 'asg' ? 'Select Upscale Time' : 'Select Start Time'}
                                            // disablePast={true}
                                            onError={() => setWeeklyStartTime(defaultDayjsDate)}
                                            closeOnSelect={false}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid>
                        </>
                    ) : (
                        // Other Than Weekly Case
                        <>
                            <Grid item xs={12}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DateTimePicker']} sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#425466',
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: '#425466', //Label color (default)
                                        },
                                        '& .MuiSvgIcon-root': {
                                            color: '#506C84', //Dropdown arrow icon
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#425466', //Selected value color
                                            fontWeight: '600'
                                        },
                                    }}>
                                        <DateTimePicker
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                },
                                            }}
                                            value={stopdate}
                                            label={type === 'asg' ? 'Select Downscale Time' : 'Select Stop Datetime'}
                                            disablePast={true}
                                            timezone={timezoneValue}
                                            onChange={(value) => setStopDate(value)}
                                            onError={() => setStopDate(defaultDayjsDate)}
                                            closeOnSelect={false}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DateTimePicker']} sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#425466',
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: '#425466', //Label color (default)
                                        },
                                        '& .MuiSvgIcon-root': {
                                            color: '#506C84', //Dropdown arrow icon
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#425466', //Selected value color
                                            fontWeight: '600'
                                        },
                                    }}>
                                        <DateTimePicker
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                },
                                            }}
                                            value={startdate}
                                            timezone={timezoneValue}
                                            onChange={(newValue) => setStartDate(newValue)}
                                            label={type === 'asg' ? 'Select Upscale Time' : 'Select Start Datetime'}
                                            disablePast={true}
                                            onError={() => setStartDate(defaultDayjsDate)}
                                            closeOnSelect={false}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid>
                        </>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    className='submit-btn'
                    onClick={() => onSave({
                        startDate: recurringOption === 'WEEKLY' ? `${weeklyScheduleEndDate.format('YYYY-MM-DD')} ${weeklyStartTime.format('HH:mm:ss')}` : startdate,
                        stopDate: recurringOption === 'WEEKLY' ? `${weeklyScheduleFromDate.format('YYYY-MM-DD')} ${weeklyStopTime.format('HH:mm:ss')}` : stopdate,
                        recurringOption,
                        selectedDays,
                        desireCount,
                        minimumCount,
                        timezone: selectedTimezone['value'] ?? selectedTimezone
                    })}
                    variant='outlined'
                    disabled={stopdate === null || startdate === null}
                >
                    Save
                </Button>
            </DialogActions>
        </BootstrapDialog>
    );
}

